var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M6 8.66663L10 4.66663L14 8.66663M10 5.33329V15.3333","stroke":"currentColor","stroke-opacity":"0.56","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }